export { default } from './LabelCDS';
